
export class DataListModel<T> {
    constructor(
        public data: T[], 
        public length: number = data && data.length,
    ) {}       
}
